import TemporalConverterBase from '@migrate/utils/date/TemporalConverterBase'
import { convert, Temporal, ZonedDateTime } from '@js-joda/core'

export default class ZonedDateTimeConverter extends TemporalConverterBase {
  localizationOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  }

  private readonly value: ZonedDateTime

  constructor(value: ZonedDateTime) {
    super()
    this.value = value
  }

  public getValue(): Temporal {
    return this.value
  }

  toNative(): Date {
    return convert(this.value).toDate()
  }
}
